import { RootState } from "../../../store";
import { dimensionsSliceSelector } from "../dimensionsSliceSelector";

export const categoryFilterTypeSelector = (state: RootState) => {
  const slice = dimensionsSliceSelector(state);

  return slice.filterType;
};
